import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    products: [],
    productsCount: 0,
    product: {},
    productSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getProducts(state) {
      return state.products
    },
    getProductsCount(state) {
      return state.productsCount
    },
    getProduct(state) {
      return state.product
    },
    getProductSaveStatus(state) {
      return state.productSave
    },
  },
  mutations: {
    PRODUCTS_LIST(state, data) {
      state.products = data
    },
    PRODUCT_VIEW(state, data) {
      state.product = data
    },
    PRODUCTS_COUNT(state, data) {
      state.productsCount = data
    },
    PRODUCT_SAVE(state, data) {
      state.productSave = data
    },
  },
  actions: {
    productsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/products/getData', data)
        .then(response => {
          commit('PRODUCTS_LIST', response.data.data)
          commit('PRODUCTS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    productView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'products.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/products/getData', data)
        .then(response => {
          commit('PRODUCT_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    productSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/products/saveData', data)
        .then(response => {
          commit('PRODUCT_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
